import Media from '@/components/shared/Media/Media';
import { ArrowRight } from '@1debit/icons';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { RelatedArticleProps } from 'libs/contentful/props';
import Link from 'components/shared/Link/Link';
import { getRichTextValue } from 'utils/formatters';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const MediumArticle = ({ articleImage, articleTitle, category, slug, sys }: RelatedArticleProps) => {
  const categoryTitle = category?.label;
  const linkText = 'Read more';
  const plainTitle = getRichTextValue(articleTitle);

  // TODO: incorporate alternateTitle and alternateImage from Page: Blog to
  // override the article and image used in this component
  return (
    <div data-testid={'mediumArticle'} className={'flex flex-col sm:max-w-105 h-full gap-y-6'}>
      {articleImage && (
        <div className="h-50 sm:h-64 w-full" {...liveUpdateAttrs(sys?.id, 'articleImage')}>
          <Media
            media={articleImage}
            sizes={'(max-width: 750px) 100vw, 420px'}
            className={'object-cover max-h-full max-w-full'}
          />
        </div>
      )}
      <div className="space-y-2.5">
        <div className="font-serif text-eyebrow font-normal capitalize leading-[1.4]">{categoryTitle}</div>
        <div className="font-sans space-y-8">
          <div className="text-heading-sm" {...liveUpdateAttrs(sys?.id, 'articleTitle')}>
            <Link internalPage={{ slug }}>
              <RichTextHeadline headline={articleTitle} />
            </Link>
          </div>
          <div className="text-label-saans">
            <Link internalPage={{ slug }} className={'hover:underline'} aria-label={`${linkText}: ${plainTitle}`}>
              {linkText} <ArrowRight className={'inline size-(--ck-icon-size)'} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediumArticle;
